if (!customElements.get('size-quick-add')) {
  customElements.define(
    'size-quick-add',
    class SizeQuickAdd extends HTMLElement {
      connectedCallback() {
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.addEventListener('click', this.onClick.bind(this));
      }

      onClick(evt) {
        const button = evt.target.closest('button[data-variant-id]');
        if (!button) return;
        evt.preventDefault();
        evt.stopPropagation();
        if (button.classList.contains('loading')) return;
        this.addToCart(button);
      }

      addToCart(button) {
        button.classList.add('loading');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', button.dataset.variantId);
        formData.append('quantity', '1');
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'size-quick-add',
                productVariantId: button.dataset.variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              button.classList.add('card-sizes__option--error');
              setTimeout(() => button.classList.remove('card-sizes__option--error'), 2000);
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'size-quick-add',
              productVariantId: button.dataset.variantId,
              cartData: response,
            });
            if (this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            this.cart.renderContents(response);

            button.classList.add('card-sizes__option--added');
            setTimeout(() => button.classList.remove('card-sizes__option--added'), 1500);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            button.classList.remove('loading');
          });
      }
    }
  );
}
